import React, { useState } from 'react';
import './GroceryCard.css';
import { logger } from '../utils/logger';

const GroceryCard = ({ item, onToggleListItem, onAddToList, shoppingList = [] }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  // Check if this item is in the shopping list
  const isSelected = shoppingList.some(
    listItem => listItem.name === item.name && listItem.store === item.store
  );
  
  // Debug: log if image exists (only in development)
  React.useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (item.image) {
       // logger.log(`✅ Image found for "${item.name}":`, item.image);
      } else {
      //  logger.log(`❌ No image for "${item.name}" - item.image is:`, item.image);
      }
    }
  }, [item.image, item.name]);
  
  const categoryColors = {
    meat: 'var(--category-meat)',
    seafood: 'var(--category-seafood)',
    veg: 'var(--category-veg)',
    fruit: 'var(--category-fruit)',
    pantry: 'var(--category-pantry)'
  };

  const categoryLabels = {
    meat: 'Meat',
    seafood: 'Seafood',
    veg: 'Vegetable',
    fruit: 'Fruit',
    pantry: 'Pantry'
  };

  const handleCardClick = () => {
    if (onToggleListItem) {
      onToggleListItem(item);
    } else {
      onAddToList(item);
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // Prevent card click from firing
    if (onToggleListItem) {
      onToggleListItem(item);
    } else {
      onAddToList(item);
    }
  };

  return (
    <div className={`grocery-card ${isSelected ? 'selected' : ''}`} onClick={handleCardClick}>
      {item.image && !imageError && (
        <div className="grocery-card-image-container">
          {imageLoading && (
            <div className="grocery-card-image-placeholder">Loading...</div>
          )}
          <img 
            src={item.image} 
            alt={item.name}
            className="grocery-card-image"
            loading="lazy"
            onLoad={() => setImageLoading(false)}
            onError={() => {
              logger.error(`Failed to load image for ${item.name}:`, item.image);
              setImageError(true);
              setImageLoading(false);
            }}
          />
          {item.photographerName && (
            <div className="grocery-card-attribution-overlay">
              Photo by{' '}
              <a 
                href={item.photographerProfileUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="attribution-link"
                onClick={(e) => e.stopPropagation()}
              >
                {item.photographerName}
              </a>
              {' '}on{' '}
              {item.unsplashPhotoUrl ? (
                <a 
                  href={item.unsplashPhotoUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="attribution-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  Unsplash
                </a>
              ) : (
                <span>Unsplash</span>
              )}
              .
            </div>
          )}
        </div>
      )}
      <div 
        className="grocery-card-category"
        style={{ backgroundColor: categoryColors[item.category] || 'var(--color-surface-alt)' }}
      >
        {categoryLabels[item.category] || item.category}
      </div>
      <div className="grocery-card-content">
        <h3 className="grocery-card-name">{item.name}</h3>
        <p className="grocery-card-price">${item.price.toFixed(2)}</p>
        <button
          className="grocery-card-add-btn"
          onClick={handleButtonClick}
        >
          {isSelected ? 'Remove from List' : 'Add to List'}
        </button>
      </div>
    </div>
  );
};

export default GroceryCard;

